/*=========================================================================================
  File Name: moduleInventoryActions.js
  Description: Inventory Module Actions
==========================================================================================*/

import inventoryGql from "@/http/requests/rice/inventory_gql.js";
import customerCardGql from "@/http/requests/card/customer_gql";

export default {
	fetchInventories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.fetchInventories(payload)
				.then(response => {
					commit("SET_INVENTORIES", response.inventories);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_INVENTORY", false);
					reject(error);
				});
		});
	},
	toggleInventoryCategorySideBar({ commit }, payload) {
		commit("SET_INVENTORY_CATEGORY_SIDEBAR_STATUS", payload.status);
	},
	updateInventory({ commit }, payload) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.updateInventory(payload)
				.then(response => {
					commit("UPDATE_INVENTORY", response.inventory);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_INVENTORY", false);
					reject(error);
				});
		});
	},

	addInventory({ commit }, payload) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.addInventory(payload)
				.then(response => {
					commit("ADD_NEW_INVENTORY", response.inventory);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_INVENTORY", false);
					reject(error);
				});
		});
	},

	deleteInventory({ commit }, payload) {
		return new Promise((resolve, reject) => {
			inventoryGql
				.deleteInventory(payload)
				.then(response => {
					commit("DELETE_INVENTORY", response.inventory);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_INVENTORY", false);
					reject(error);
				});
		});
	},
	fetchListKCS({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.getListProductStocks(payload)
				.then(response => {
					commit("SET_KCS_LIST", response.product_stocks);
					commit("SET_KCS_TOTAL", response.total);
					resolve(response);
				})
				.catch(error => {
					// commit("SET_IS_FETCHED_INVENTORY", false);
					reject(error);
				});
		});
	},
	updateKCS({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.updateProductStock(payload)
				.then(response => {
					commit("UPDATE_KCS", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addKCS({ commit }, payload) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.createProductStock(payload)
				.then(response => {
					commit("ADD_NEW_KCS", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	exportProductStock({ commit }, id) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.exportProductStock(id)
				.then(response => {
					commit("UPDATE_KCS", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deleteProductStock({ commit }, id) {
		return new Promise((resolve, reject) => {
			customerCardGql
				.deleteProductStock(id)
				.then(response => {
					commit("DELETE_KCS", id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
